import FuseChipSelect from "@fuse/components/FuseChipSelect/FuseChipSelect";
import _ from "@lodash";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import clsx from "clsx";
import { withFormsy } from "formsy-react";
import React from "react";

function FuseChipSelectFormsy(props) {
  const importedProps = _.pick(props, [
    "children",
    "classes",
    "className",
    "defaultValue",
    "disabled",
    "fullWidth",
    "id",
    "label",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "textFieldProps",
    "variant",
    "isMulti",
    "options",
    "errorMessage",
  ]);

  // An error message is returned only if the component is invalid
  const { errorMessage, value } = props;

  function changeValue(val) {
    if (props.multiple) {
      // react-select returns an array of option objects or null
      const valuesArray = Array.isArray(val)
        ? val.map((option) => option?.value)
        : [];
      props?.setValue(valuesArray);
      return;
    }
    // Single value
    if (val == null) {
      props?.setValue(null);
      return;
    }
    // val can be an option object { value, label }
    if (typeof val === "object" && val !== null && "value" in val) {
      props?.setValue(val.value);
      return;
    }
    // Fallback: pass through
    props?.setValue(val);
  }

  return (
    <FormControl
      error={Boolean(
        (!props.isPristine && props.showRequired) || errorMessage
      )}
      className={clsx(
        props.className,
        "z-10",
        props.showRequired ? "required" : "",
        props.showError ? "error" : null
      )}
      variant={importedProps.variant}
    >
      {props.label && (
        <InputLabel htmlFor={props.name}>{props.label}</InputLabel>
      )}
      <FuseChipSelect
        {...importedProps}
        value={value}
        onChange={changeValue}
        error={Boolean(
          (!props.isPristine && props.showRequired) || errorMessage
        )}
      />
      {Boolean(errorMessage) && (
        <FormHelperText>{errorMessage}</FormHelperText>
      )}
    </FormControl>
  );
}

export default React.memo(withFormsy(FuseChipSelectFormsy));
